import React, {useState, useEffect} from 'react'
import {inject, observer} from 'mobx-react'
import DialogModal from '../../../DialogModal'
import {Icon, IconTypes, TextButton, TextButtonTypes} from '../../../Buttons'
import css from './style.css'
import {DropDown} from '../../../InputForms'
import styles from '../../../AddTaskModal/components/Form/style.css'

const logoTypes = [
  {
    label: 'LARGE',
    value: 'LARGE'
  }
]

const logoColourSchemes = [
  {
    label: 'REGULAR',
    value: 'REGULAR'
  },
  {
    label: 'DARK',
    value: 'DARK'
  }
]


const LogoUploadModal = inject('localizationStore')(observer(function LogoUploadModal({agent, onClose, localizationStore}) {
  const [currentImage, setCurrentImage] = useState(undefined)
  const [nextImage, setNextImage] = useState(null)
  const [file, setFile] = useState(null)
  const [type, setType] = useState(logoTypes[0].value)
  const [color, setColor] = useState(logoColourSchemes[0].value)

  async function getLogo() {
    const blob = await agent.getLargeLogoRequest(type, color)
    if (blob) {
      setCurrentImage(window.URL.createObjectURL(blob))
    } else {
      setCurrentImage(null)
    }
  }

  async function handleUpload() {
    await agent.uploadLargeLogoRequest(file, type, color)
    getLogo()
  }

  function onChange(e) {
    switch (e.target.name) {
      case 'next_image':
        setFile(e.target.files[0])
        break;
      case 'type':
        setType(e.target.value)
        break;
      case 'color':
        setColor(e.target.value)
        break;
      default:

    }
  }

  async function deleteCurrent() {
    try {
      await agent.deleteLargeLogoRequest(type, color)
      setCurrentImage(null)
    } catch (e) {
    }
  }

  useEffect(() => {
    setCurrentImage(undefined)
    getLogo()
  }, [type, color])

  useEffect(() => {
    if (file && file.type.startsWith('image')) {
      const url = window.URL.createObjectURL(file)
      setNextImage(url)
      return () => {
        window.URL.revokeObjectURL(url)
      }
    }
    return undefined
  }, [file])

  const {locale} = localizationStore
  const confirmButton =
    <TextButton
      text={locale.upload_logo}
      type={TextButtonTypes.primary}
      onClick={handleUpload}
      disabled={!file} />
  return <DialogModal onClose={onClose} button={confirmButton}>
    <DropDown label={'Type'} options={logoTypes} name={'type'} value={type} onChange={onChange}/>
    <DropDown label={'Color scheme'} options={logoColourSchemes} name={'color'} value={color} onChange={onChange}/>
    <div className={css.uploadLogoContainer}>
      <div>
        <h3>Current</h3>
        {currentImage === undefined && 'Loading'}
        {currentImage === null && 'No image'}
        {typeof currentImage === 'string' && <React.Fragment>
          <img src={currentImage} alt={'current logo'} style={color === 'DARK' ? {background: 'black'} : undefined}/>
          <Icon type={IconTypes.delete} onClick={deleteCurrent}/>
        </React.Fragment>}
      </div>
      <div>
        <h3>Upload</h3>
        {nextImage && <img src={nextImage} alt={'next logo'} style={color === 'DARK' ? {background: 'black'} : undefined}/>}
        <input type={'file'} name={'next_image'} onChange={onChange}/>
      </div>
    </div>
  </DialogModal>
}))

export default LogoUploadModal



// WEBPACK FOOTER //
// ./src/components/AgentInfo/components/LogoUpload/index.js